import { Loader2 } from "lucide-react";

import { cn } from "@/shared/lib/utils";

export function StatCard({
  label,
  value,
  tone = "default",
}: {
  label: string;
  value: number;
  tone?: "default" | "warn" | "ok" | "danger";
}) {
  return (
    <div
      className={cn(
        "rounded-lg border px-3 py-2.5 min-w-0",
        tone === "warn" && "border-amber-500/40 bg-amber-500/5",
        tone === "ok" && "border-emerald-500/40 bg-emerald-500/5",
        tone === "danger" && "border-destructive/40 bg-destructive/5"
      )}
    >
      <p className="text-[10px] uppercase tracking-wide text-muted-foreground font-medium truncate">
        {label}
      </p>
      <p className="text-xl font-semibold tabular-nums leading-tight mt-0.5">
        {value}
      </p>
    </div>
  );
}

export function LoadingBlock() {
  return (
    <div className="flex justify-center py-16" role="status" aria-live="polite">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      <span className="sr-only">Cargando inventario</span>
    </div>
  );
}

export function EmptyBlock({ message }: { message: string }) {
  return (
    <div className="rounded-lg border border-dashed py-10 text-center text-sm text-muted-foreground">
      {message}
    </div>
  );
}
